(function () {
  'use strict';

  angular
    .module('events.vehicles.deposits')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('events.vehicles.deposits', {
        abstract: true,
        url: '/:vehicleId/deposits',
        templateUrl: 'events/vehicles/deposits/deposits.tpl.html'
      });
  }
}());
